<template lang="pug">
  <div class="es-nosotros es-page">
    .es-inner
      .es-banner-main
        header.es-banner-main__header
          h1.es-banner-main__title.es-title Nosotros
        picture.es-banner-main__wrapper-img
          source(class="es-banner-main__img" srcset="../assets/img/banner-nosotros-desk-min.jpg" media="(min-width: 768px)")
          img(class="es-banner-main__img" src="../assets/img/banner-nosotros-mobile-min.jpg" alt="Personas viajando felices")
    .es-inner
      section.es-about__content
        article.es-grid-aside#conocenos
          .es-grid-aside__item-lateral
            h2.es-subtitle Conócenos
          .es-grid-aside__item-content
            .es-grid-aside__item-separate
              h3.es-subsubtitle Misión
              p.es-txt EXPRESO DEL SOL S.A.S, es líder en la prestación de servicios de transporte terrestre intermunicipal de pasajeros por carretera a nivel nacional, ofreciendo un servicio de calidad excepcional. Nos enfocamos en la seguridad vial, la salud en el trabajo, la protección del medio ambiente y la máxima satisfacción de nuestros clientes.
              p.es-txt Nuestro objetivo es brindar un servicio confiable, cómodo y eficiente a nuestros pasajeros, asegurándoles un viaje seguro y placentero. Para lograrlo, contamos con un equipo altamente competente y comprometido, que se esfuerza por superar las expectativas de nuestros clientes y usuarios en cada trayecto.
            .es-grid-aside__item-separate
              h3.es-subsubtitle Visión
              p.es-txt EXPRESO DEL SOL S.A.S, se proyecta en 10 años como líder en el mercado de transporte terrestre intermunicipal de pasajeros. Esforzados por lograr un reconocimiento sólido y un posicionamiento destacado; impulsados por la implementación continua de herramientas tecnológicas e innovadoras. <br>Buscando constantemente la mejora y expansión de nuestras rutas, con el objetivo de superar las necesidades y expectativas de nuestros clientes y usuarios. Enfocada en ofrecer un servicio excepcional que se distinga por su calidad, eficiencia y comodidad.
              p.es-txt Para lograrlo, se compromete a utilizar de manera eficiente los recursos,  mantener un parque automotor moderno y en óptimas condiciones. Además, apostamos por la adopción de tecnologías vanguardistas que nos permitan ofrecer un servicio diferenciado y preferido por nuestros clientes a la hora de movilizarse de un lugar a otro.
            .es-grid-aside__item-separate
              h3.es-subsubtitle Valores corporativos
              ul.es-list-general
                li.es-list-general__item Respeto
                li.es-list-general__item Honestidad
                li.es-list-general__item Lealtad
            .es-grid-aside__item-separate
              h3.es-subsubtitle Principios Corporativos
              ul.es-list-general
                li.es-list-general__item Compromiso
                li.es-list-general__item Buen trato
                li.es-list-general__item Unión
            .es-grid-aside__item-separate
              h3.es-subsubtitle Sistema de Gestión de Seguridad y Salud en el Trabajo
              p.es-txt Es un conjunto de Actividades dirigidas a proteger y promover la salud de los trabajadores mediante la prevención y el control de enfermedades y accidentes, y la eliminación de los factores y condiciones que ponen en peligro la salud y la seguridad en el trabajo.
        article.es-grid-aside#convenios
          .es-grid-aside__item-lateral
            h2.es-subtitle Convenios
          .es-grid-aside__item-content
            .es-grid-aside__item-separate
              img.es-about__img(src="../assets/img/logo-tst.jpg" alt="logo tst")
            .es-grid-aside__item-separate
              h3.es-subsubtitle Parque automotor
              p.es-txt Disfruta de una experiencia de viaje inolvidable en el parque automotor que ponemos a tu disposición. Viaja directo a donde quieres ir con todos los servicios que necesitas para sentirte cómodo y seguro. <br>Te ofrecemos vehículos con tecnología innovadora, que te permitirán sentirte cómodo desde el momento de tu abordaje, contamos con una plataforma tecnológica de rastreo satelital monitoreada 24/7 por personal debidamente capacitado, garantizándote así seguridad y tranquilidad durante todo tu viaje.
        ComfortList
    .es-inner#tipos-flota
      h2.es-subtitle Tipos de flota
      button.es-tab-simulated.i-arrow-bottom(v-on:click="toggleList()" :class="{ active: toggleListBoolean }")
        p.es-tab-simulated__txt {{ innerText }}
      tabs.es-vertical-tabs(:class="{ active: toggleListBoolean }")
        tab(title="Aerován")
          .es-tabs__grid
            .es-tabs__grid-item
              h3.es-subsubtitle Aerován
              figure.es-tabs__grid-figure
                img.es-tabs__img(class="es-banner-main__img" src="../assets/img/aerovan.png" alt="")
        tab(title="Microbús")
          .es-tabs__grid
            .es-tabs__grid-item
              h3.es-subsubtitle Microbús
              figure.es-tabs__grid-figure
                img.es-tabs__img(class="es-banner-main__img" src="../assets/img/microbus.png" alt="")
        tab(title="Buseta")
          .es-tabs__grid
            .es-tabs__grid-item
              h3.es-subsubtitle Buseta
              figure.es-tabs__grid-figure
                img.es-tabs__img(class="es-banner-main__img" src="../assets/img/buseta.png" alt="")
        tab(title="Bus")
          .es-tabs__grid
            .es-tabs__grid-item
              h3.es-subsubtitle Bus
              figure.es-tabs__grid-figure
                img.es-tabs__img(class="es-banner-main__img" src="../assets/img/bus.png" alt="")
        tab(title="Microbús de lujo")
          .es-tabs__grid
            .es-tabs__grid-item
              h3.es-subsubtitle Microbús de lujo (próximamente)
              figure.es-tabs__grid-figure
                img.es-tabs__img(class="es-banner-main__img" src="../assets/img/grid-aside-bus.png" alt="")
        tab(title="Bus de lujo")
          .es-tabs__grid
            .es-tabs__grid-item
              h3.es-subsubtitle Bus de lujo (próximamente)
              figure.es-tabs__grid-figure
                img.es-tabs__img(class="es-banner-main__img" src="../assets/img/grid-aside-bus.png" alt="")

  </div>
</template>

<script>
import { Tabs, Tab } from "vue-slim-tabs";
import ComfortList from "@/components/ComfortList.vue";

export default {
  name: "Services",
  components: {
    Tabs,
    Tab,
    ComfortList,
  },
  data() {
    return {
      text: null,
      toggleListBoolean: null,
      innerText: null,
    };
  },
  mounted: function() {
    this.tabSelected();
    let texto = document.querySelectorAll(".vue-tab");
    for (var i = 0; i < texto.length; i++) {
      texto[i].addEventListener("click", this.tabSelected);
    }
  },
  watch: {
    innerText: function() {
      this.innerText;
    },
    totalItems: function() {
      this.totalItems;
    },
  },
  methods: {
    tabSelected() {
      this.text = document.querySelectorAll("li[aria-selected=true]");
      this.innerText = this.text[0].innerText;
      if (this.toggleListBoolean) {
        this.toggleListBoolean = null;
      }
    },
    toggleList() {
      this.toggleListBoolean = !this.toggleListBoolean;
    },
  },
};
</script>

<style src="vue-slim-tabs/themes/default.css"></style>
